import React from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import { useEffect } from "react";
import Spinner from "../../component/loadingbar/Spinner";

const AddRoom = () => {
  const { id } = useParams();
  const token = config.token;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  //-------------------------------------------------- state management --------------------------------------
  const [room, setRoom] = useState("");

  const handleRoomChange = (e) => {
    setRoom(e.target.value);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setRoom("");

    if (id) {
      navigate("/viewrooms");
    }
  };

  //---------------------------------------------- update / edit room ----------------------------------------------------u
  useEffect(() => {
    if (id !== undefined) {
      setLoading(true);
      fetch(`${config.host_url}rooms/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setRoom(data.data.room);
          setLoading(false);
        });
    }
  }, [id]);

  // ---------------------------------------------- create / add room ----------------------------------------------------c
  // Function to create a new room
  const addRoomBtn = async () => {
    try {
      if (!room.trim()) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(
        `${config.host_url}rooms/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            room: room,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Course created successfully
            triggerNotification(
              "success",
              `${
                id ? "Room updated successfully." : "Room created successfully."
              }`
            );
            setRoom("");
            navigate("/viewrooms");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating room:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the room."
      );
    }
  };

  return (
    <>
      <Breadcrumb txt="Manage Room" subpath={["Add Room"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Room</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* room Name */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control "
                    name="room"
                    id="room"
                    placeholder="Room Name"
                    value={room}
                    onChange={handleRoomChange}
                  />
                  <label htmlFor="room"> Room Name</label>
                </div>
                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={addRoomBtn}
                    >
                      {id ? "update" : "Submit"}
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddRoom;
